export const OFFLINE_UPDATE_READY_EVENT = "chams-offline-update-ready";

export async function registerOfflineShell(): Promise<void> {
  if (!("serviceWorker" in navigator) || import.meta.env.DEV) return;
  try {
    const registration = await navigator.serviceWorker.register("/service-worker.js", {
      scope: "/",
    });
    const notify = () => window.dispatchEvent(new Event(OFFLINE_UPDATE_READY_EVENT));
    if (registration.waiting) notify();
    registration.addEventListener("updatefound", () => {
      const worker = registration.installing;
      worker?.addEventListener("statechange", () => {
        if (worker.state === "installed" && navigator.serviceWorker.controller) notify();
      });
    });
    const checkForUpdate = () => {
      if (document.visibilityState === "visible") void registration.update().catch(() => undefined);
    };
    window.addEventListener("focus", checkForUpdate);
    document.addEventListener("visibilitychange", checkForUpdate);
    checkForUpdate();
  } catch {
    // The connected shell remains usable; availability is reported in owner validation.
  }
}

export async function activateWaitingOfflineUpdate(): Promise<boolean> {
  const registration = await navigator.serviceWorker.getRegistration("/");
  if (!registration?.waiting) return false;
  registration.waiting.postMessage({ type: "CHAMS_ACTIVATE_UPDATE" });
  return true;
}
